import { map } from 'rxjs/operators';
import { DataUtilService } from 'src/app/_services/data-util.service';
import { AuthHeader } from './../_models/headers';


import { HttpClient } from '@angular/common/http';

import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { environment } from '../../environments/environment';
import { AuthService } from './auth.service';
@Injectable({
  providedIn: 'root'
})
export class GroupingsService {
  aHeader = undefined

  public minGroupingData=new BehaviorSubject<any>({});
  public subscriptionGrouping:Object=undefined

  constructor(
    private http: HttpClient,
    private dataUtilService:DataUtilService,private tss:AuthService) { this.aHeader = new AuthHeader(tss)}

  getWebPendingQuiz(serverStudentUserId: number,quiz_mode_name:string) {
    let pp = new URLSearchParams()
    pp.set("id",serverStudentUserId.toString())
    pp.set("quiz_mode_name",quiz_mode_name)

   return this.http.post(`${environment.apiUrl}/subscriptionGrouping/pendingQuiz`,pp.toString(),this.aHeader.bearerFormHeaders).pipe(map(data => {
     let student:any= {}
     if(this.dataUtilService.isGoodResponse(data)){
       student= this.dataUtilService.myData(data)
     }

     return student
   }))
}

getWebDoneQuiz(serverStudentUserId: number,quiz_mode_name:string) {
  let pp = new URLSearchParams()
  pp.set("id",serverStudentUserId.toString())
  pp.set("quiz_mode_name",quiz_mode_name)

 return this.http.post(`${environment.apiUrl}/subscriptionGrouping/doneQuiz`,pp.toString(),this.aHeader.bearerFormHeaders).pipe(map(data => {
   let student:any= {}
   if(this.dataUtilService.isGoodResponse(data)){
     student= this.dataUtilService.myData(data)
   }

   return student
 }))
}
getGroupingQuiz(server_quiz_id:number){
  return this.http.get(`${environment.apiUrl}/quiz/getGroupingQuiz/${server_quiz_id}`,this.aHeader.bearerJsonHeaders).pipe(map(data => {
    let student:any= {}
    if(this.dataUtilService.isGoodResponse(data)){
      student= this.dataUtilService.myData(data)
    }

    return student
  }))
}
}
